module.exports = __webpack_public_path__ + "img/D1000.60116e41.png";